export const appendModals = () => {
  document.querySelectorAll('.modal').forEach(el => {
    // Modals need to be outside ADF to display
    document.body.append(el)
  })
};